<template>
	<v-text-field
		:id="id"
		ref="quantityInput"
		:label="label"
		:loading="loading"
		:disabled="disabled"
		:hide-details="hideDetails"
		outlined
		:rules="rules"
		class="mt-3 pt-0"
		v-model="quantityinput"
		type="number"
		maxlength="13"
		step="1"
		min="0"
		size="13"
		:append-outer-icon="appendOuterIcon"
		:placeholder="placeholder"
		v-on:click:append-outer="$emit('click:append-outer', true)"
		v-on:onchange="$emit('onchange', true)"
		v-on:keypress="limitDecimal($event, quantityinput)"
		v-on:keyup="$emit('keyup', true)"
	></v-text-field>
</template>
<script>
export default {
	name: "quantity-input",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			type: [String, Number],
			default: null,
		},
		rules: {
			type: [Array, Object],
			default: () => {
				return [];
			},
		},
		placeholder: {
			type: String,
			default: null,
		},
		id: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		appendOuterIcon: {
			type: String,
			default: null,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			quantityinput: null,
		};
	},
	watch: {
		value() {
			this.quantityinput = this.value;
		},
		quantityinput() {
			this.$emit("input", this.quantityinput);
		},
	},
	mounted() {
		this.quantityinput = this.value;
	},
};
</script>
